import { type PHEmploymentMenuItem } from "../Employment.types";

export const employmentMenuItemsLoanonlinePH: PHEmploymentMenuItem[] = [
  { label: "inputs.employment.employed", value: "EMPLOYED" },
  { label: "inputs.employment.self_employed", value: "SELF_EMPLOYED" },
  { label: "inputs.employment.business_owner", value: "BUSINESS_OWNER" },
  { label: "inputs.employment.freelancer", value: "FREELANCER" },
  { label: "inputs.employment.not_employed", value: "UNEMPLOYED" },
  { label: "inputs.employment.other", value: "OTHER" },
];
